import * as yup from 'yup';

export const fileUploadSchema = (isUpdating = false) =>
  isUpdating
    ? yup.object().shape({ name: yup.string().required('Required field') })
    : yup.object().shape({
        name: yup.string().required('Required field'),
        file: yup.mixed().required('Required field'),
      });
